<script setup>
import { useSlots } from 'vue'
import { useVModel } from '@vueuse/core'
import { getI18n } from '@/plugins/i18n'

const slots = useSlots()

const i18n = getI18n()

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: false,
    default: null,
  },
  icon: {
    type: String,
    required: false,
  },
  iconColor: {
    type: String,
    required: false,
    default: 'primary',
  },
  iconSize: {
    type: String,
    required: false,
    default: undefined,
  },
  label: {
    type: String,
    required: false,
    default: null,
  },
  cancelLabel: {
    type: String,
    required: false,
    default: null,
  },
  size: {
    type: String,
    required: false,
    default: 'xxs',
  },
})

const emit = defineEmits(['confirm', 'cancel', 'update:modelValue'])

const value = useVModel(props, 'modelValue', emit)

</script>
<template>
  <q-dialog
    v-model="value"
    :class="`dialog-${props.size}`"
    persistent
  >
    <q-card>
      <q-card-section
        v-if="props.title"
        class="row items-center no-wrap"
      >
        <q-avatar
          v-if="props.icon"
          :icon="props.icon"
          :color="props.iconColor"
          text-color="white"
        />
        <div class="text-h6 q-ml-sm">{{ props.title }}</div>
      </q-card-section>
      <q-card-section
        class="row items-center"
        style="flex-flow: row;"
        :class="{ 'q-pt-none': props.title }"
      >
        <q-avatar
          v-if="props.icon && !props.title"
          :icon="props.icon"
          :color="props.iconColor"
          :size="props.iconSize"
          text-color="white"
        />
        <span v-if="props.message" :class="{ 'q-ml-sm': !props.title }">{{ props.message }}</span>
      </q-card-section>
      <q-card-section v-if="slots.default">
        <slot />
      </q-card-section>
      <q-card-actions align="right">
        <q-btn
          v-close-popup
          flat
          :label="props.cancelLabel || i18n.t('common.cancel')"
          @click="emit('cancel')"
        />
        <q-btn
          v-close-popup
          flat
          :label="props.label || i18n.t('common.confirm')"
          color="primary"
          @click="emit('confirm')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
